<template>
  <div class="page">
    <div class="qr">
      <v-qr-code class="code" :qrString="qrString" title="我的取餐码" status=''></v-qr-code>
    </div>
    <v-button text='返回' primary @click="$router.back()" class="button"></v-button>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import api from '../api'
import mixin from './mixin'
export default {
  mixins: [mixin],
  data () {
    return {
      qrString: '',
      timer: undefined
    }
  },
  computed: {
    ...mapState({ user: state => state.user })
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  created () {
    this.setTitle('我的取餐码')
    this.showLoading()
    if (this.timer) {
      clearInterval(this.timer)
    }
    this.timer = setInterval(() => {
      this.updateData()
    }, 60 * 1000)
    this.updateData()
  },
  methods: {
    updateData () {
      api.getPersonQrCodeString(this.user).then((data) => {
        this.qrString = data
        this.hideLoading()
      }, (data) => {
        this.hideLoading()
        this.showToast(data, 'cancel')
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.page
  background #F2F3F4
  min-height 100vh
  padding-top 40px
  padding-bottom 10px
  .qr
    padding 8pt
  .button
    margin 8pt
    center-with-padding()
</style>



// WEBPACK FOOTER //
// my-qr-code.vue?3c8e0380